.d9{aspect-ratio:1/1;}